import { useEffect, useState } from 'react';
import Header from '../header';
import {
  Select,
  MenuItem,
  Box,
  Button,
  Card,
  CardContent, IconButton,
  Table,
  TableBody, TableContainer, Tooltip
} from '@mui/material';
import Iconify from 'src/components/iconify';
import {
  emptyRows,
  getComparator,
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  TablePaginationCustom,
  TableSelectedAction,
  useTable,
} from 'src/components/table';
import { useBoolean } from 'src/hooks/use-boolean';
import Scrollbar from 'src/components/scrollbar';
import { applyFilter } from 'src/layouts/_common/searchbar/utils';
import { isEqual } from 'lodash';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { deleteRequest, getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { LoadingScreen } from 'src/components/loading-screen';
import { LoadingButton } from '@mui/lab';
import UserTableRow from './expense-table-row';
import ExpensesCreate from './expenses-create-form';


const Expenses = () => {
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [employeeOptions, setemployeeOptions] = useState([]);
  const [departmentsOptions, setdepartmentsOptions] = useState([]);
  const [categoryOptions, setcategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [createdby, setcreatedby] = useState([]);
  const [customerList, setcustomerList] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [projectList, setprojectList] = useState([]);
  const [costcenterList, setcostcenterList] = useState([]);
  const [chartsAccountList, setchartsAccount] = useState([]);
  const [selectedProject, setSelectedProject] = useState('All');


  const TABLE_HEAD = [
    { id: 'Sr.No', label: 'Sr.no' },
    { id: 'Date', label: 'Date', minWidth: 130 },
    { id: 'Client', label: 'Vendors/Customers', width: '300px', minWidth: 130 },
    { id: 'Project Name', label: 'Project Name', minWidth: 130 },
    { id: 'Description', label: 'Description', minWidth: 130 },
    { id: 'Charts of account', label: 'Charts of account', minWidth: 150 },
    { id: 'Debit', label: 'Debit', minWidth: 130 },
    { id: 'Credit', label: 'Credit', minWidth: 130 },
    { id: 'Notes/Remarks', label: 'Notes/Remarks', minWidth: 130 },
    { id: 'expense_type', label: 'Type', minWidth: 130 },
    { id: 'Status', label: 'Status', minWidth: 130 },
    { id: 'Action', label: 'Action' },
  ];
  
  const table = useTable();
  const remove = useBoolean();

  const confirm = useBoolean();
  const create = useBoolean();
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useState({
    name: '',
    role: [],
    status: 'all',
  });
  const dataFiltered = applyFilter({
    inputData: tableData.length > 0 ? tableData : [],
    comparator: getComparator(table.order, table.orderBy),
    filters,
  });
  const dataInPage = dataFiltered.slice(
    table.page * table.rowsPerPage,
    table.page * table.rowsPerPage + table.rowsPerPage
  );
  const denseHeight = table.dense ? 52 : 72;
  const canReset = !isEqual({ name: '', role: [], status: 'all' }, filters);
  const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

  const handleEditRow = (item) => {
    setSelectedItem(item);
    create.onTrue();
  };

  useEffect(() => {
    getExpensesData();
    getEmployeeName()
    getDepartments()
    getCatgeory()
    // getSubCatgeory()
    getCreatedBy()
    getVendors()
    getProjets()
    getCostCenter()
    getChartsOfAccount()
    getCustomersList()
  }, []);



  const getCustomersList = async () => {
    const data = await getRequest(endpoints.accounting.customers.get_list);
    const transformedOptions = data?.map(user => ({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
    })) || [];
    setLoading(false);
    if (data) {
      setcustomerList(transformedOptions);
    }
  };
  const getExpensesData = async () => {
    setLoading(true);
    const data = await getRequest(endpoints.accounting.expenses.get_list);
    setLoading(false);
    if (data) {
      setTableData(data);
    }
  };
  const getEmployeeName = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_employee_list);
    if (data) {
      setemployeeOptions(data);
    }
  };
  const getDepartments = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_departments_list);
    if (data) {
      setdepartmentsOptions(data);
    }
  };
  const getCostCenter = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_cost_center_list);
    if (data) {
      setcostcenterList(data);
    }
  };
  const getChartsOfAccount = async () => {
    const data = await getRequest(endpoints.accounting.expenses.charts_of_account_list);
    if (data) {
      setchartsAccount(data);
    }
  };
  const getCatgeory = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_category_list);
    if (data) {
      setcategoryOptions(data);
    }
  };
  const getSubCatgeory = async (url) => {
    const data = await getRequest(url);
    if (data) {
      setSubCategoryOptions(data);
      console.log(subCategoryOptions, 'sub cat options')
    }
  };
  const getProjets = async () => {
    const data = await getRequest(endpoints.accounting.expenses.get_project_list);
    if (data) {
      setprojectList(data);
    }
  };

  const getCreatedBy = async () => {
    setLoading(true);
    const data = await getRequest(endpoints.accounting.documents.get_all_users);
    const transformedOptions = data?.map(user => ({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
    })) || [];
    setLoading(false);
    if (data) {
      setcreatedby(transformedOptions);
    }
  };

  const getVendors = async () => {
    setLoading(true);
    const data = await getRequest(endpoints.accounting.vendors.get_list);
    setLoading(false);
    const transformedOptions = data?.map(user => ({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
    })) || [];
    if (data) {
      setVendorsList(transformedOptions);
    }
  };


  const handleChange = (event) => {
    setSelectedProject(event.target.value);
  };


  const deleteCallBack = () => {
    confirm.onFalse();
    getExpensesData();
  };

  const handleCloseForm = () => {
    create.onFalse();
    setSelectedItem({});
    table.onSelectAllRows(false, []);
  };

  const handleDeleteRow = async (id) => {
    setDeleteLoading(true)
    await deleteRequest(`${endpoints.accounting.expenses.delete}/${id}`, deleteCallBack);
    const updatedTableData = tableData.filter((row) => row.id !== id);
    setTableData(updatedTableData);
    if (updatedTableData.length <= table.page * table.rowsPerPage && table.page > 0) {
      table.onChangePage(null, table.page - 1);
    } else {
      table.onUpdatePageDeleteRow(dataInPage.length);
    }
    setDeleteLoading(false)
  }


  const handleBulkDelete = async () => {
    const Ids = table.selected;
    if (Ids.length > 0) {
      try {
        const response = await postRequest(
          endpoints.risk_management.risk_change_request.bulk_delete,
          { ids: Ids }
        );
        remove.onFalse();
        getExpensesData();
      } catch (error) {
        console.error('Error during bulk delete:', error);
      }
    } else {
      console.warn('No rows selected');
    }
  };

  return (
    <>
      <Card sx={{ height: '100%', marginTop: '10px', overflow: 'hidden' }}>
        {' '}
        <CardContent>
          {loading ? (
            <Box height={700}>
              <LoadingScreen />
            </Box>
          ) : (
            <>
              <Header name="Expenses Management" />
              <Box
                sx={{
                  display: 'flex',
                  paddingBottom: '20px',
                  justifyContent: 'space-between',
                  gap: '12px',
                  marginTop: '15px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    padding: '5px 0',
                  }}
                >
                  <h5
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#333',
                      margin: '0',
                      textTransform: 'none',
                    }}
                  >
                    Project Name
                  </h5>
                  <Select
                    sx={{ minWidth: 65, height: 35 }}
                    value={selectedProject}
                    onChange={handleChange}
                  >
                    <MenuItem value="All">All</MenuItem>
                    {projectList?.map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))}
                  </Select>

                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    paddingBottom: '20px',
                    justifyContent: 'flex-end',
                    gap: '12px',
                  }}
                >
                  <Button
                    onClick={() => {
                      setSelectedItem({});
                      create.onTrue();
                    }}
                    className="dark-button"
                    variant="contained"
                    startIcon={<Iconify icon="mingcute:add-line" />}
                  >
                    Create
                  </Button>
                </Box>
              </Box>
              <Card
                sx={{
                  boxShadow: '0px 0px 30px 0px #64748B1A',
                }}
              >
                <TableContainer sx={{ position: 'relative', overflow: 'auto' }}>
                  <Scrollbar>
                    <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                      <TableSelectedAction
                        dense={table.dense}
                        numSelected={table.selected.length}
                        rowCount={tableData.length}
                        onSelectAllRows={(checked) =>
                          table.onSelectAllRows(
                            checked,
                            tableData.map((row) => row.id)
                          )
                        }
                        action={
                          <Tooltip title="Delete">
                            <IconButton color="primary" onClick={confirm.onTrue}>
                              <Iconify icon="solar:trash-bin-trash-bold" />
                            </IconButton>
                          </Tooltip>
                        }
                      />

                      <Scrollbar>
                        <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 960 }}>
                          <TableHeadCustom
                            order={table.order}
                            orderBy={table.orderBy}
                            headLabel={TABLE_HEAD}
                            rowCount={tableData.length}
                            numSelected={table.selected.length}
                            onSort={table.onSort}
                            onSelectAllRows={(checked) =>
                              table.onSelectAllRows(
                                checked,
                                tableData.map((row) => row.id)
                              )
                            }
                          />
                          <TableBody>
                            {dataFiltered
                              .slice(
                                table.page * table.rowsPerPage,
                                table.page * table.rowsPerPage + table.rowsPerPage
                              )
                              .map((row, index) => (
                                <UserTableRow
                                  key={row.id}
                                  row={row}
                                  selected={table.selected.includes(row.id)}
                                  onSelectRow={() => table.onSelectRow(row.id)}
                                  onDeleteRow={() => handleDeleteRow(row.id)}
                                  onEditRow={() => handleEditRow(row)}
                                  serialNumber={table.page * table.rowsPerPage + index + 1}
                                />
                              ))}
                            <TableEmptyRows
                              height={denseHeight}
                              emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                            />

                            <TableNoData notFound={notFound} />
                          </TableBody>
                        </Table>
                      </Scrollbar>
                    </TableContainer>
                  </Scrollbar>
                </TableContainer>
                <TablePaginationCustom
                  count={dataFiltered.length}
                  page={table.page}
                  rowsPerPage={table.rowsPerPage}
                  onPageChange={table.onChangePage}
                  onRowsPerPageChange={table.onChangeRowsPerPage}
                  dense={table.dense}
                  onChangeDense={table.onChangeDense}
                />
              </Card>
            </>
          )}
        </CardContent>
      </Card>
      <ExpensesCreate
        open={create.value}
        onClose={create.onFalse}
        reload={() => getExpensesData()}
        currentItem={selectedItem}
        closeform={() => handleCloseForm()}
        employeeOptions={employeeOptions}
        departmentsOptions={departmentsOptions}
        categoryOptions={categoryOptions}
        subCategoryOptions={subCategoryOptions}
        vendorsList={vendorsList}
        getSubCat={getSubCatgeory}
        relaodCatgeory={()=>getCatgeory()}
        relaodDepartments={()=>getDepartments()}
        relaodCostCenter={()=>getCostCenter()}
        projectList={projectList}
        costcenterList={costcenterList}
        chartsAccountList={chartsAccountList}
        customerList={customerList}
      />
      <ConfirmDialog
        open={remove.value}
        onClose={remove.onFalse}
        title="Delete"
        content={<>Are you sure want to delete these items?</>}
        action={
          <LoadingButton
            loading={deleteLoading}
            variant="contained"
            className="dark-button"
            onClick={() => {
              handleBulkDelete();
            }}
          >
            Delete
          </LoadingButton>
        }
      />
    </>
  );
};
export default Expenses;